import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { PanelConfig, SidebarStateEvent } from "./sidebar.component";

@Injectable({ providedIn: "root" })
export class SidebarService {
  private readonly isOpenStreamSub = new Subject<{ panelName: string; isOpen: boolean } | void>();
  private readonly stateEventSub = new Subject<SidebarStateEvent>();
  private readonly panelsSub = new BehaviorSubject<Array<PanelConfig>>([]);

  /** @private sidebar events */
  readonly _isOpenStream$ = this.isOpenStreamSub.asObservable();
  /** @public state event stream */
  readonly stateEvent$ = this.stateEventSub.asObservable();
  /** @public state panels stream */
  readonly panels$ = this.panelsSub.asObservable();

  openPanel(panelName: string): void {
    this.isOpenStreamSub.next({ isOpen: true, panelName });
  }

  closePanel(panelName?: string): void {
    this.isOpenStreamSub.next(panelName ? { isOpen: false, panelName } : void 0);
  }

  _updateStateEvent(event: SidebarStateEvent): void {
    this.stateEventSub.next(event);
  }

  _updatePanels(event: Array<PanelConfig>): void {
    this.panelsSub.next(event);
  }
}
